import * as R from 'ramda';
import { ChatParticipant, ChatRoomInitialParticipants } from '../types/chat.types';

export const sortChatParticipantByName = (a: ChatParticipant, b: ChatParticipant) => {
  const formattedA = a.commercialName.toLocaleLowerCase();
  const formattedB = b.commercialName.toLocaleLowerCase();
  if (formattedA > formattedB) {
    return 1;
  }
  if (formattedA < formattedB) {
    return -1;
  }
  return 0;
};

export const mergeListWithInputParticipants = (
  inputParticipants: ChatParticipant[],
  chatParticipants: ChatParticipant[],
) => {
  const sortedInputParticipants = inputParticipants.sort(sortChatParticipantByName);
  const participants = inputParticipants.length
    ? [...sortedInputParticipants, ...chatParticipants]
    : chatParticipants;
  return R.uniqBy(({ id }) => id, participants);
};

export const formatInitialParticipants = (participants?: ChatRoomInitialParticipants) => {
  if (!participants) {
    return [];
  }

  return participants.stores;
};
